import type { Strings } from './en';

export const th: Strings = {
  brand: { name: 'OpenSoi' },
  nav: {
    home: 'แผนที่',
    search: 'ค้นหา',
    add: 'เพิ่มร้าน',
    profile: 'โปรไฟล์',
    notifications: 'แจ้งเตือน',
    signin: 'เข้าสู่ระบบ',
    signout: 'ออกจากระบบ',
    back: 'ย้อนกลับ',
    skip: 'ข้าม',
    settings: 'ตั้งค่า',
  },
  lang: { toggle: 'English' },
  hero: {
    title: 'เปิดร้านไหนในซอยตอนนี้',
    sub: 'สถานะสดจากคนที่เดินผ่านจริง 300+ ร้านทั่วกรุงเทพ สองภาษา ฟรี',
  },
  live: {
    now: 'เปิดอยู่ตอนนี้',
    closed: 'ปิด',
    unknown: 'ยังไม่มีรายงาน',
    just_opened: 'เพิ่งเปิด',
    last_report: 'รายงานล่าสุด {{minutes}} นาทีที่แล้ว',
  },
  vote: {
    open: 'เปิดอยู่',
    closed: 'ปิดอยู่',
    success_short: 'บันทึกแล้ว +{{points}}',
    success_long: 'บันทึกแล้ว ขอบคุณที่บอกต่อ',
    geofence: 'คุณอยู่ห่างจากแผงขายเกินไป',
    rate_limited: 'คุณเพิ่งโหวตร้านนี้ภายใน 30 นาที',
    sign_in_required: 'เข้าสู่ระบบเพื่อโหวตและสะสมแต้ม',
    network_error: 'เชื่อมต่อเซิร์ฟเวอร์ไม่ได้ ลองอีกครั้ง',
    geo_denied: 'อนุญาตการเข้าถึงตำแหน่งเพื่อโหวต',
    geo_timeout: 'อ่านตำแหน่งของคุณไม่ได้ ลองอีกครั้ง',
    geo_unavailable: 'เบราว์เซอร์นี้ไม่รองรับตำแหน่ง',
  },
  auth: {
    title: 'เข้าสู่ระบบเพื่อโหวต',
    body: 'ดูได้ฟรี ล็อกอินเฉพาะตอนจะโหวต รีวิว หรือบันทึกร้านโปรด',
    google: 'เข้าสู่ระบบด้วย Google',
    skip: 'ดูต่อไปก่อน',
    error: 'เข้าสู่ระบบไม่สำเร็จ ลองอีกครั้ง',
  },
  search: {
    placeholder: 'ค้นหาร้าน อาหาร หรือซอย…',
    empty_title: 'ไม่เจอในซอยนี้',
    empty_hint: 'ลองค้นเมนูอื่น หรือช่วยเพื่อนหิว เพิ่มร้านนี้เลย',
    empty_cta: 'เพิ่มเลย →',
    trending: 'ค้นมากในย่านนี้',
  },
  home: {
    nearby_count_one: '{{count}} ร้าน',
    nearby_count_other: '{{count}} ร้าน',
    offline_preview: 'พรีวิวออฟไลน์',
    empty_hint: 'ลองซอยอื่น หรือซูมออก',
    filter: {
      open_now: 'เปิดอยู่ตอนนี้',
      noodle: 'ก๋วยเตี๋ยว',
      grill: 'ปิ้งย่าง',
      isan: 'ส้มตำ · อีสาน',
      sweets: 'ของหวาน',
      late: 'ของกินดึก',
    },
  },
  empty: {
    morning: 'หาข้าวเช้าในซอย',
    midday: 'หิวยัง?',
    afternoon: 'ของว่างบ่ายๆ',
    evening: 'ตอนนี้ใครเปิด',
    late: 'ของกินดึก',
    deep_night: 'ยังหิวอยู่?',
  },
  errors: {
    offline: 'ตอนนี้เชื่อมต่อ OpenSoi ไม่ได้',
    retry: 'ลองใหม่',
    not_found: 'ไม่พบร้านนี้',
    page_not_found: 'ไม่พบหน้านี้',
    stall_temporarily_unavailable: 'โหลดข้อมูลร้านนี้ไม่ได้ตอนนี้',
    back_to_map: 'กลับไปที่แผนที่',
  },
  profile: {
    points: 'แต้ม',
    next_badge_hint: 'โหวตต่อเพื่อปลดล็อกตราถัดไป',
    badges: 'ตราสะสม',
    no_leaderboard: 'ไม่มีลีดเดอร์บอร์ดสาธารณะ ตราสะสมไว้ส่วนตัว',
    data_account: 'ข้อมูลและบัญชี',
    view_privacy: 'นโยบายความเป็นส่วนตัว',
    delete_account: 'ลบบัญชี',
    pdpa_note: 'การลบบัญชีจะลบข้อมูลส่วนตัวภายใน 30 วัน (PDPA)',
    stats: {
      reports: 'รายงาน',
      reviews: 'รีวิว',
      stalls_added: 'เพิ่มร้าน',
    },
  },
  onboarding: {
    slide1_title: 'รู้ทันที ร้านไหนเปิด',
    slide1_body:
      'คนเดินผ่านโหวต 1 คลิก คุณเห็นสดๆ ไม่ต้องเดินไปเสียเที่ยว',
    slide2_title: 'ต้องอยู่ในซอย',
    slide2_body:
      'โหวตได้เฉพาะเมื่ออยู่ในระยะ 100 เมตรจากร้าน เพื่อความซื่อสัตย์ของสัญญาณ ดูได้ฟรีโดยไม่ต้องล็อกอิน',
    slide3_title: 'สะสมแต้มเพื่อซอย',
    slide3_body:
      'โหวต รีวิว เพิ่มร้าน — ได้แต้มและตราสะสม ไม่มีลีดเดอร์บอร์ด ไม่มีอวด แค่ความรู้สึกอบอุ่นที่ช่วยคนหิวคนต่อไป',
    next: 'ถัดไป →',
    skip: 'ข้าม',
    finish: 'เข้าสู่ระบบ →',
  },
  add: {
    title: 'รู้จักร้านที่ยังไม่มี? เพิ่มเลย',
    note_queue: 'ผู้ดูแลตรวจร้านใหม่ภายใน 24 ชม. ได้ +50 แต้มเมื่ออนุมัติ',
    step_basics: '1 · ชื่อและเมนู',
    step_location: '2 · ปักหมุดและเวลา',
    step_photo: '3 · รูปเดียวก็พอ',
    field_name: 'ชื่อร้าน',
    field_name_helper: 'ใส่ทั้ง TH/EN ได้ ชื่อแบรนด์/สถานที่ใช้ภาษาต้นฉบับ',
    field_category: 'หมวด',
    field_dishes: 'เด่นเรื่อง…',
    field_dishes_helper: 'เมนูที่ร้านนี้ขึ้นชื่อ 1-2 อย่าง',
    field_hours: 'เวลาเปิด-ปิดปกติ',
    field_address: 'ที่อยู่ / ซอยใกล้สุด',
    field_address_helper: 'เราจะตรวจย่านจากหมุดให้',
    photo_title: 'แนบรูป 1 รูป',
    photo_body: 'รูปคาร์ตชัดๆ ช่วยให้ผู้ดูแลอนุมัติเร็วขึ้น ตัด EXIF บนอัปโหลด ขนาดสูงสุด 2 MB',
    next_to_location: 'ถัดไป: ปักหมุดและเวลา →',
    next_to_photo: 'ถัดไป: รูป →',
    submit: 'ส่งให้ผู้ดูแล',
    submitting: 'กำลังส่ง…',
    back: '← ย้อนกลับ',
    not_wired: 'API การส่งร้านกำลังเชื่อมต่อ ข้อมูลของคุณบันทึกชั่วคราว ยังไม่ได้ส่งจริง',
    name_required: 'กรุณาใส่ชื่อร้านก่อนไปต่อ',
    pin_required: 'ต้องอนุญาตการเข้าถึงตำแหน่งเพื่อปักหมุดร้าน',
    pin_locating: 'กำลังหาตำแหน่งของคุณ…',
    pin_set: 'ปักหมุดที่ {{lat}}, {{lng}}',
    pin_waiting: 'กด ถัดไป เพื่อใช้ตำแหน่งปัจจุบัน',
    photo_required: 'เลือกรูป 1 รูปก่อนส่ง',
    photo_preview_alt: 'ตัวอย่างรูปที่เลือก',
    photo_type_error: 'รับเฉพาะ JPEG, PNG, หรือ WEBP เท่านั้น',
    photo_size_error: 'รูปต้องไม่เกิน 2 MB',
    sign_in_required: 'กรุณาเข้าสู่ระบบเพื่อส่งร้าน',
    network_error: 'เชื่อมต่อเซิร์ฟเวอร์ไม่ได้ ลองอีกครั้ง',
    geo_denied: 'ไม่ได้รับอนุญาตให้เข้าถึงตำแหน่ง — กรุณาเปิดเพื่อปักหมุด',
    geo_timeout: 'หมดเวลาขอตำแหน่ง — ลองอีกครั้ง',
    geo_unavailable: 'อ่านตำแหน่งของคุณไม่ได้ ลองอีกครั้ง',
    success_pending: 'ส่งเรียบร้อย! ผู้ดูแลจะตรวจภายใน 24 ชม.',
    success_published: 'ขึ้นแล้ว! ขอบคุณที่เพิ่มร้านนี้',
  },
  reviews: {
    title: 'เขียนรีวิว',
    rating_label: 'ให้คะแนน',
    tags_label: 'แท็ก (ไม่บังคับ)',
    body_label: 'รีวิวของคุณ',
    body_placeholder: 'เป็นยังไงบ้าง พูดตรงๆได้',
    photo_label: 'รูป (ไม่บังคับ)',
    photo_helper: 'รูปเดียว ของจริงไม่ต้องแต่ง',
    post: 'โพสต์รีวิว',
    posting: 'กำลังโพสต์…',
    cancel: 'ยกเลิก',
    points_note: '+10 แต้มสำหรับรีวิวแรก +5 แต้มเมื่อแก้ไข',
    not_wired: 'API รีวิวกำลังเชื่อมต่อ บันทึกร่างไว้ในเครื่องของคุณก่อน',
    success: 'ขอบคุณ — รีวิวของคุณขึ้นแล้ว',
    sign_in_required: 'กรุณาเข้าสู่ระบบเพื่อโพสต์รีวิว',
    network_error: 'เชื่อมต่อเซิร์ฟเวอร์ไม่ได้ ลองอีกครั้ง',
    tags: {
      worth_queue: 'คุ้มค่าการรอ',
      bring_friend: 'พามาเพื่อน',
      cash_only: 'เงินสดเท่านั้น',
      spicy: 'เผ็ด',
      late_night: 'ของกินดึก',
      hidden_gem: 'ของลับ',
    },
  },
  notifications: {
    intro: 'แจ้งเฉพาะเรื่องสำคัญ ไม่มีโปรโมชั่นหรือโฆษณา',
    none_yet_title: 'ยังไม่มีการแจ้งเตือน',
    none_yet_body:
      'เราจะแจ้งเมื่อร้านโปรดเปิด ร้านที่คุณส่งได้รับการอนุมัติ หรือคุณปลดล็อกตรา',
    what_we_send: 'เราจะแจ้งเตือนคุณเรื่องอะไรบ้าง',
    bullets: {
      favorite_opened: 'ร้านโปรดของคุณเพิ่งเปิด',
      submission_approved: 'ร้านที่คุณส่งได้รับการอนุมัติ (หรือต้องการข้อมูลเพิ่ม)',
      badge_unlocked: 'ตราที่คุณใกล้ปลดล็อกพร้อมแล้ว',
      weekly: 'สรุปประจำสัปดาห์ ปิดได้',
    },
    promise:
      'ไม่มีโปรโมชั่น ไม่มีโฆษณา ไม่มี "ห่างหายไปนานแล้ว — กลับมาเล่นเถอะ" ถ้าส่งมา แปลว่ามีเรื่องจริงในซอยของคุณ',
  },
};
